import { KeyValueData } from '../domains/common.domain';

/*export const LocationData = {
  postcode: '80331',
  city: 'Munich',
  street: '12th A',
  street_number: 102,
  district: 'Munich',
  gps: '52.425364, 10.794253',
  reason: 'Update meter installations',
  power: false,
  gas: true,
  water: false,
  heating: false,
  powerType: '',
  gasType: '',
  waterType: '',
  districtHeatingType: '',
};*/

export const AllDropdownKeys = {
  ApplicationStatus: 'sk_status',
  ApplicationType: 'sk_application_type',
  ApplicationTypeDetail: 'sk_application_type_detail',
  BuildingType: 'sk_building_type',
  PowerConnectionType: 'power_connection_type',
  dhwType: 'sk_swkn_districthead_system_type',
  ChangeSubtype: 'sk_change_subtype',
  Communication: 'sk_communication',
  DevelopmentAreaType: 'sk_development_area_type',
  DevelopmentAreaName: 'sk_development_area_name',
  DeviceLocation: 'sk_device_location',
  WaterDeviceLocation: 'sk_water_device_location',
  WaterDeviceLocationNew: 'sk_water_device_location-new',
  DocumentType: 'sk_document_type',
  EventType: 'sk_app_event_type',
  ExecutorType: 'sk_executor_action',
  ExpectedAnnualConsumption: 'sk_estimated_annual_consumption',
  FacilityType: {
    gas: 'sk_gas_facility_type',
    heating: 'sk_districtheat_facility_type',
    power: 'sk_power_facility_type',
    water: 'sk_water_facility_type',
  },
  FacilityTypeNew: {
    gas: 'sk_gas_facility_type-new',
    heating: 'sk_districtheat_facility_type-new',
    power: 'sk_power_facility_type-new',
    water: 'sk_water_facility_type-new',
  },
  FeedInMeasuringConcept: 'sk_measuring_concept',
  FeedInSystemType: 'sk_feedin_type',
  FeedInType: 'sk_feedin_inst_type',
  GasDeviceLocation: 'sk_gas_device_location',
  GasMeterSize: 'sk_gas_meter_size',
  GasMeterType: 'sk_gas_meter_type',
  GridConApplicationType: 'sk_gridcon_application_type',
  HeatingDeviceLocation: 'sk_districtheat_device_location',
  HeatingDistributionType: 'sk_districtheat_distribution_type',
  HeatingMeterSize: 'sk_heat_meter_size',
  HeatingMeterType: 'sk_districtheat_meter_type',
  HeatingTypeOfHeating: 'sk_districtheat_heating_type',
  HotWaterPrepType: 'sk_hotwater_prep_type',
  InstallationChangeType: 'sk_inst_change_type',
  InstallationChangeTypeGas: 'sk_inst_change_type_gas',
  InstallationChangeTypeHeating: 'sk_inst_change_type_districtheat',
  InstallationChangeTypeWater: 'sk_inst_change_type_water',
  InstallationType: 'sk_installation_type',
  MeasuringPointOperator: 'sk_measuring_point_operator',
  MeterMount: 'sk_meter_mount',
  ModernMeterSubtype: 'sk_modern_meter_subtype',
  DoublerateMeterSubtype: 'sk_doublerate_meter_subtype',
  SwknShutdownReason: 'sk_swkn_shutdown_reason',
  SwknHeatMeterSize: 'sk_swkn_heat_meter_size',
  OrderProcess: 'sk_orderprocess_status',
  PowerMeterType: 'sk_power_meter_type',
  SelectedGasCategory: 'sk_selected_gas_category',
  DeviceManufacturer: 'sk_device_manufacturer',
  DeviceCategory: 'sk_device_category',
  RequiredFlowPressure: 'sk_required_flow_pressure',
  SpecialConsumerType: 'sk_specialconsumer_type',
  SWKNBlockIntervalsType: 'sk_swkn_block_intervals',
  TappingPointType: 'sk_tappingpoint_type',
  TappingPointTypeNew: 'sk_tappingpoint_type-new',
  TempSpecialConsumerType: 'sk_tmp_specialconsumer_type',
  Title: 'sk_title',
  TransducerSize: 'sk_transducer_size_a',
  VariableCosts: 'sk_variable_costs',
  WaterMeterSize: 'sk_water_meter_size',
  WaterMeterType: 'sk_water_meter_type',
  WaterMeterTypeNew: 'sk_water_meter_type-new',
  SWKNWaterFacilitySystemTypeNew: 'sk_swkn_water_facility_system_type-new',
  SWKNRequiredFusePower: 'sk_swkn_required_fuse_power',
  InternalPowerSiteCon: 'sk_internal_power_sitecon',
  ExternalPowerSiteCon: 'sk_external_power_sitecon',
  SiteConPowerSubtype: 'sk_sitecon_power_subtype',
  SiteConCurrent: 'sk_sitecon_current',
  ConstructionSpec: 'sk_construction_spec',
  OuterShellThickness: 'sk_outershell_thickness',
  PipeUnit: 'sk_pipe_with_unit',
  AssessmentBase: 'sk_assessment_base',
  FuelType: 'sk_fuel_type',
  CombustionBoiler: 'sk_combustion_boiler_ventilation_type',
  WaterPipeMaterial: 'sk_water_pipe_material',
  WaterInstallationType: 'sk_water_installation_type',
  WaterRefluxFuse: 'sk_water_reflux_fuse',
  WaterDevices: 'sk_water_devices',
  GasUsageFor: 'sk_gas_usage_for',
  PowerConnectionLocation: 'power_connection_location',
  PowerConnectionHeatingType: 'power_connection_heating_type',
  EarthworkAreaName: 'sk_earthwork_area_name',
  consumptionDeviceControlType: 'sk_consumption_device_control',
};

export const UrlSegments: KeyValueData = {
  // personal-data APIs
  SaveBusinessPartner: 'businesspartner',
  SaveConnectionObject: 'connectionobject',
  SaveInvoiceAddress: 'invoicerecipient',
  UpdateBusinessPartner: 'businesspartner?businesspartner_id',
  UpdateConnectionObject: 'connectionobject?connectionobject_id',
  UpdateInvoiceAddress: 'invoicerecipient?recipient_id=',

  // Location
  GetLocationDetails: 'location',
  SearchLocations: 'location/search',

  // installation-application APIs
  Application: 'application',
  CreateGasFacility: 'gasfacility',
  CreateGasInstallation: 'gasinstallation',
  CreateGasMeter: 'gasmeter',
  CreateOldGasMeter: 'oldgasmeter',
  CreateGasDevice: 'gasdevice',
  CreateGasFiringSystem: 'fireingsystem',
  CreateGasFurnace: 'furnance',
  CreateHeatingFacility: 'districtheatfacility',
  CreateHeatingInstallation: 'districtheatinstallation',
  CreateHeatingMeter: 'districtheatmeter',
  CreateOldHeatingMeter: 'olddistrictheatmeter',
  CreateInstallationApplication: 'installationapplication',
  CreateGridCompFeedInApplication: 'grid-comp-feed-in-application',
  UpdateGridCompFeedInApplication: 'grid-comp-feed-in-application?application_id=',
  CreatePowerFacility: 'powerfacility',
  CreatePowerInstallation: 'powerinstallation',
  CreatePowerMeter: 'powermeter',
  CreateOldPowerMeter: 'oldpowermeter',
  CreatePowerSpecialConsumer: 'powerspecialconsumer',
  CreateWaterFacility: 'waterfacility',
  CreateWaterInstallation: 'waterinstallation',
  CreateWaterMeter: 'watermeter',
  CreateOldWaterMeter: 'oldwatermeter',
  CreateWaterDevice: 'watertappingpoint',
  InstallationApplication: 'installationapplication?application_id=',
  GridCompFeedInApplication: 'grid-comp-feed-in-application?application_id=',
  ExistingInstallationApplication: 'installationapplication?sk_status=created&sk_installation_type=',
  ExistingGridCompFeedInApplication: 'grid-comp-feed-in-application?sk_status=created&sk_type=',
  GridCompFeedInApplicationByExternalId: 'grid-comp-feed-in-application/ByExternalId',
  UpdateGasFacility: 'gasfacility?facility_id',
  UpdateGasInstallation: 'gasinstallation?installation_id',
  UpdateGasMeter: 'gasmeter?meter_id',
  UpdateOldGasMeter: 'oldgasmeter?meter_id',
  UpdateGasDevice: 'gasdevice?device_id',
  UpdateGasFiringSystem: 'fireingsystem?system_id',
  UpdateGasFurnace: 'furnance?furnance_id',
  UpdateHeatingFacility: 'districtheatfacility?facility_id',
  UpdateHeatingInstallation: 'districtheatinstallation?installation_id',
  UpdateHeatingMeter: 'districtheatmeter?meter_id',
  UpdateOldHeatingMeter: 'olddistrictheatmeter?meter_id',
  UpdateInstallationApplication: 'installationapplication?application_id=',
  UpdatePowerFacility: 'powerfacility?facility_id',
  UpdatePowerInstallation: 'powerinstallation?installation_id',
  UpdatePowerMeter: 'powermeter?meter_id',
  UpdateOldPowerMeter: 'oldpowermeter?meter_id',
  UpdatePowerSpecialConsumer: 'powerspecialconsumer?specialconsumer_id',
  UpdateWaterFacility: 'waterfacility?facility_id',
  UpdateWaterInstallation: 'waterinstallation?installation_id',
  UpdateWaterMeter: 'watermeter?meter_id',
  UpdateOldWaterMeter: 'oldwatermeter?meter_id',
  UpdateWaterDevice: 'watertappingpoint?tappingpoint_id',
  FeedInInstallation: 'feedininstallation',
  FeedInFacility: 'feedinfacility',
  FeedInInverter: 'feedininverter',
  FeedInGenerator: 'feedingenerator',
  FeedInStorage: 'feedinstorage',
  FeedInConstructor: 'feedinconstructor',
  FeedInInstaller: 'feedininstaller',
  GetMeterCharacteristic: 'metercharacteristic?meter_size=',

  // Zerez Api Integration
  ZerezApiConfiguration: 'zerez/config',
  ZerezApiUnit: 'zerez/unit',

  // grid-connection APIs
  CreateGridConnectionApplication: 'gridconapplication',
  CreateGasGridConnection: 'gasgridcon',
  CreateHeatingGridConnection: 'districtheatgridcon',
  CreatePowerGridConnection: 'powergridcon',
  CreatePowerGridSpecialConsumer: 'powergridconspecialconsumer',
  CreateWaterGridConnection: 'watergridcon',
  DeterminePrice: 'gridconapplication/updateprice?application_id=',
  GridConnectionApplication: 'gridconapplication?application_id=',
  ExistingGridConnectionApplication: 'gridconapplication?sk_status=created&sk_gridconapplication_type=',
  ApproveGridConnectionApplication: 'gridconapplication/approve?application_id=',
  RejectGridConnectionApplication: 'gridconapplication/reject?application_id=',
  UpdateGasGridConnection: 'gasgridcon?gridcon_id=',
  UpdateHeatingGridConnection: 'districtheatgridcon?gridcon_id=',
  UpdatePowerGridConnection: 'powergridcon?gridcon_id=',
  UpdatePowerGridSpecialConsumer: 'powergridconspecialconsumer?specialconsumer_id=',
  UpdateWaterGridConnection: 'watergridcon?gridcon_id=',
  GridConnResendOwnerEmail: 'gridconapplication/resend-owner-email?orderProcessId=',

  // grid-compatibility APIs
  GridCompApplication: 'gridCompApplication',
  CreatePowerPlantOperatorAddress: 'gridCompApplication/operatorAddress',
  UploadGridCompDocuments: 'gridCompApplication/documents',

  // grid compatibility order process
  GridCompOrderProcessByApplication: 'gridCompOrderProcess/forApplication/',
  IssuePermission: 'gridCompOrderProcess/:id/issuePermission',
  DenyRequest: 'gridCompOrderProcess/:id/denyRequest',
  OpenIssue: 'gridCompOrderProcess/:id/openIssue',
  WithdrawRequest: 'gridCompOrderProcess/:id/withdrawRequest',
  WithdrawAndCopyRequest: 'gridCompOrderProcess/:id/withdrawAndCopyRequest/:applicationId?sk_status=:sk_status&sk_type=:sk_type',
  UpdateRequest: 'gridCompOrderProcess/:id/updateRequest',
  RequestExtension: 'gridCompOrderProcess/:id/requestExtension',
  SaveResultData: 'gridCompOrderProcess/:id/resultData',

  // grid compatibility comment
  GridCompTechnicalSpecificationsSectionComment: 'gridCompComment/technical-specifications-section',
  GridCompPersonalDataSectionComment: 'gridCompComment/personal-data-section',
  GridCompDocumentsSectionComment: 'gridCompComment/document-section',

  // registration of energy producer order process
  RegepOrderProcessByApplication: 'registrationOfEnergyProducerOrderProcess/forApplication/',
  RegepEngineeringOpenIssue: 'registrationOfEnergyProducerOrderProcess/:id/engineering/openIssue',
  RegepEngineeringUpdateRequest: 'registrationOfEnergyProducerOrderProcess/:id/engineering/updateRequest',
  RegepEngineeringOk: 'registrationOfEnergyProducerOrderProcess/:id/engineering/ok',
  RegepSaveEegEnergyProducers: 'registrationOfEnergyProducerOrderProcess/:id/saveEegEnergyProducers',
  RegepCustomerDataAdded: 'registrationOfEnergyProducerOrderProcess/:id/customer/addData',
  RegepRegulationsOpenIssue: 'registrationOfEnergyProducerOrderProcess/:id/regulations/openIssue',
  RegepRegulationsUpdateRequest: 'registrationOfEnergyProducerOrderProcess/:id/regulations/updateRequest',
  RegepRegulationsOk: 'registrationOfEnergyProducerOrderProcess/:id/regulations/ok',
  RegepApproveRequest: 'registrationOfEnergyProducerOrderProcess/:id/approveRequest',
  RegepDenyRequest: 'registrationOfEnergyProducerOrderProcess/:id/denyRequest',
  RegepWithdrawRequest: 'registrationOfEnergyProducerOrderProcess/:id/withdrawRequest',
  RegepWithdrawAndCopyRequest: 'registrationOfEnergyProducerOrderProcess/:id/withdrawAndCopyRequest/:applicationId',

  // registration of energy producer comment
  RegepTechnicalSpecificationsSectionComment: 'registrationOfEnergyProducerComment/technical-specifications-section',
  RegepPersonalDataSectionComment: 'registrationOfEnergyProducerComment/personal-data-section',
  RegepDocumentsSectionComment: 'registrationOfEnergyProducerComment/document-section',
  RegepRegulatorySectionComment: 'registrationOfEnergyProducerComment/regulatory-data-section',

  // custom-fields APIs
  CustomFields: 'customFields',
  CustomFieldsConfig: 'customFields/config',

  // Registration of energy producer (RegEP)
  RegistrationOfEnergyProducerApplication: 'registrationOfEnergyProducerApplication',
  RegistrationOfEnergyProducerTechnicalData: 'registrationOfEnergyProducerApplication/technicalData',
  UploadRegistrationOfEnergyProducerDocuments: 'registrationOfEnergyProducerApplication/documents',
  RegepCreatePowerPlantOperatorAddress: 'registrationOfEnergyProducerApplication/operatorAddress',
  RegistrationOfEnergyProducerRegulatoryData: 'registrationOfEnergyProducerRegulatoryData',
  RegistrationOfEnergyProducerExport: 'registrationOfEnergyProducerExport/report/:applicationId',
  RegistrationOfEnergyProducerApplicationByStatus: 'registrationOfEnergyProducerApplication/skstatus',
  RegepResendOwnerEmail: 'registrationOfEnergyProducerApplication/resend-owner-email?applicationId=',

  // app location
  AppLocation: 'app-location',
  GetAppLocationByApplicationId: 'app-location/:applicationId',

  // copy application data
  CopyApplication: 'copyapplication',

  // technician
  TechnicianByBdewIdAndPower: 'technician/bdewid?bdewid=:bdewid&concessionpower=1',

  DrrCcdDeviceApplication: 'drr-ccd-device-application',
  OrderProcessExport: 'application/csv-report',
};

export const ComponentRoutes: KeyValueData = {
  ProcessDetails: 'process-details',
};

export const ZerezIdMask = {
  mask: 'ZE-****-****-****',
  charPattern: '[A-Z]',
};
